import {
    ADD_TOKEN,
    ADD_ID,
} from '../constants/AppConstants'

export const addToken = token => {
    return {
        type: ADD_TOKEN,
        payload: {
            token
        }
    }
}

export const addId = id => {
    return {
        type: ADD_ID,
        payload: {
            id
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/AppAction.js